import React from "react";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { CATEGORIES } from "../mock";

const CategoryGrid = () => {
  return (
    <section className="max-w-7xl mx-auto px-4 py-12">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#0b2960]">Nos catégories</h2>
          <p className="text-neutral-600 mt-1 text-sm">Découvrez notre sélection d'électroménager d'occasion reconditionné, garantie 4 mois</p>
        </div>
        <Link to="/boutique" className="text-sm font-semibold text-[#e11d24] hover:underline hidden sm:block">
          Voir toute la boutique →
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
        {CATEGORIES.map((cat) => {
          const Icon = LucideIcons[cat.icon] || LucideIcons.Package;
          return (
            <Link
              key={cat.id}
              to={cat.slug === "occasion" ? "/occasion" : `/boutique?cat=${cat.slug}`}
              className="group relative bg-white border border-neutral-200 rounded-lg overflow-hidden hover:border-[#0b2960] hover:shadow-lg transition-all duration-300"
            >
              <div className="aspect-square bg-neutral-50 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  loading="lazy"
                  className="w-full h-full object-cover opacity-90 group-hover:scale-110 group-hover:opacity-100 transition-all duration-500"
                />
              </div>
              <div className="p-3 text-center">
                <div className="h-9 w-9 mx-auto -mt-8 mb-1 bg-white border-2 border-[#0b2960] rounded-full flex items-center justify-center text-[#0b2960] group-hover:bg-[#e11d24] group-hover:text-white group-hover:border-[#e11d24] transition-colors">
                  <Icon className="h-4 w-4" />
                </div>
                <div className="text-xs md:text-sm font-semibold text-neutral-800 group-hover:text-[#0b2960] transition-colors">
                  {cat.name}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default CategoryGrid;
